/* eslint-disable max-len */
import BabyDogeQuestion from 'images/coin-pages/questions/babydoge.svg'

import { ICoinPageData } from '../types'
import { blogCards, commonSlidesData } from '../commonPageData'

export const babyDogePage: ICoinPageData = {
  title: 'coin_111',
  description: 'coin_112',
  // description:
  //   'Get a Baby Doge Coin loan. Receive up to 90% of your BabyDoge loan collateral in cash or crypto and continue holding. Borrow Baby Doge Coin instantly for an unlimited term and get extra funds in 15 minutes without selling your crypto.',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Baby Doge Coin (BabyDoge))' }) }} />
  ),
  questionsBlock: {
    image: BabyDogeQuestion,
    questions: [
      {
        title: 'coin_113',
        answer: 'coin_114',
      },
      {
        title: 'coin_115',
        answer: 'coin_116',
      },
      {
        title: 'coin_117',
        answer: 'coin_118',
      },
      {
        title: 'coin_119',
        answer: 'coin_120',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Baby Doge Coin (BabyDoge)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_121',
        text: ['coin_123'],
      },
      {
        title: 'coin_122',
        text: ['coin_124'],
      },
    ],
    blogCards: [blogCards.borrowLikePro, blogCards.cryptoCrash],
  },
}
